/* eslint-disable no-param-reassign */
import { PayloadAction } from "@reduxjs/toolkit"

import { ProductObjCacheState, SaveProductTitleCachePayload } from "./types"

export function saveProductObjCacheHandler(
  state: ProductObjCacheState,
  action: PayloadAction<SaveProductTitleCachePayload>
) {
  const { productType, productTypeCache } = action.payload
  state[productType] = productTypeCache
}

export function clearProductObjCacheHandler(
  state: ProductObjCacheState,
  action: PayloadAction<{ productType: string }>
) {
  const { productType } = action.payload
  delete state[productType]
}
